import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PermissionGuard } from './permission.guard';

@Injectable()
export class KYCKYBPermissionGuard extends PermissionGuard {
    canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
        const isUserBlocked = this.auth.account.isPayrollAccessBlocked;

        if (isUserBlocked) {
            return Promise.resolve(true);
        }

        return super.canActivate(route, _state);
    }
}
